import React, { useEffect } from 'react';

export default function useDisableInputFocus(props: { loading: boolean; root: React.RefObject<HTMLDivElement> }) {
  const { loading, root } = props;

  const forceInputBlur = (e?: any) => {
    e?.target?.blur();
  };

  const getEls = () => {
    const monthEls = root.current?.querySelectorAll('.calendar-filter-date-month-selector .tea-input');
    const yearEls = root.current?.querySelectorAll('.calendar-filter-date-year-selector .tea-input');
    return { monthEls, yearEls };
  };

  // 添加事件绑定
  const addEventListeners = () => {
    const { monthEls, yearEls } = getEls();

    if (monthEls) {
      for (const monthEl of monthEls) {
        monthEl?.addEventListener('focus', forceInputBlur);
      }
    }

    if (yearEls) {
      for (const yearEl of yearEls) {
        yearEl?.addEventListener('focus', forceInputBlur);
      }
    }
  };

  // 解除事件绑定
  const removeEventListeners = () => {
    const { monthEls, yearEls } = getEls();

    if (monthEls) {
      for (const monthEl of monthEls) {
        monthEl?.removeEventListener('focus', forceInputBlur);
      }
    }

    if (yearEls) {
      for (const yearEl of yearEls) {
        yearEl?.removeEventListener('focus', forceInputBlur);
      }
    }
  };

  useEffect(() => {
    if (loading) return;

    addEventListeners();

    return removeEventListeners;
  }, [loading]);
}
